import { render, staticRenderFns } from "./Simulados.vue?vue&type=template&id=75384579"
import script from "./Simulados.vue?vue&type=script&lang=js"
export * from "./Simulados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports